// Framework and third-party non-UI
import React from 'react';

// Redux, contexts, and local helpers/utils/modules

// Component specific modules (Component-styled, etc.)

// App components

// Third-party components (buttons, icons, etc.)
import { CalciteButton } from '@esri/calcite-components-react';

export type CalciteButtonProps = React.ComponentProps<typeof CalciteButton>;

const CalciteButtonWrapper = ({
  disabled,
  loading,
  ...rest
}: CalciteButtonProps) => {
  return (
    <CalciteButton
      disabled={disabled || undefined}
      loading={loading || undefined}
      {...rest}
    />
  );
};

export default CalciteButtonWrapper;
